interface Scripts {
    name: string;
    src: string;
}  
export const ScriptStore: Scripts[] = [
    {name: 'jquery', src: 'assets/js/jquery.min.js'},
    {name: 'main', src: 'assets/js/main.js'},
];
